<template>
  <div>
    <!-- Conteúdo dinâmico baseado no passo atual (e1) -->
     <v-toolbar dense :color="myAtendimento.color || 'white'" class="elevation-1 permanent-toolbar mb-4" >
      <v-row align="center" class="ma-0" justify="center">
        <!-- Ícone -->
        <v-col cols="2" class="text-center">
          <v-icon large :color="myAtendimento.colorText || 'primary'">
            mdi-ticket-account
          </v-icon>
        </v-col>

        <!-- Número da Senha -->
        <v-col cols="7" class="text-center">
          <div class="text-caption mb-n2" :class="`${myAtendimento.colorText || 'primary'}--text`">SENHA</div>
          <div class="number-display" :class="`${myAtendimento.colorText || 'primary'}--text`">
            {{ myAtendimento.codigoSigla }}{{ myAtendimento.codigo }}
          </div>
        </v-col>

        <!-- Hora de Chegada -->
        <v-col cols="3" class="text-center">
          <v-chip small :color="myAtendimento.color || 'white'" :text-color="myAtendimento.colorText || 'black'" class="time-chip">
            <v-icon x-small left>mdi-clock-outline</v-icon>
            <span class="caption">{{ converterDate(myAtendimento.dataChegada) }}</span>
          </v-chip>
        </v-col>
      </v-row>
    </v-toolbar>
    <div v-if="e1 === 1" class="step-content">
      <!-- Passo 1: Atendimento Senha -->
      <v-card flat class="mb-4">
        <v-row class="ma-0">
          <v-col cols="12" md="5" class="text-center">
            <v-card flat>
              <v-card-title class="justify-center">
                <span class="display-1 font-weight-bold grey--text text--darken-3">Senha</span>
                <span class="display-1 font-weight-bold primary--text ml-2">
                  {{ myAtendimento.codigoSigla }}{{ myAtendimento.codigo }}
                </span>
              </v-card-title>

              <v-divider class="my-2"></v-divider>

              <v-card flat class="mt-4">
                <ol class="rounded-list">
                  <li v-for="(item, index) in servicos" :key="index"><a>{{ item.nomeServico }}</a></li>
                </ol>
              </v-card>
            </v-card>
          </v-col>

          <v-divider vertical class="hidden-sm-and-down"></v-divider>

          <v-col cols="12" md="6" class="text-center">
            <v-card flat>
              <v-card-title class="justify-center">
                <span class="display-1 font-weight-bold grey--text text--darken-3">Hora Chegada</span>
                <span class="display-1 font-weight-bold primary--text ml-2">
                  {{ converterDate(myAtendimento.dataChegada) }}
                </span>
              </v-card-title>

              <v-divider class="my-2"></v-divider>

              <v-card flat class="mt-4">
                <v-card-text>
                  <div class="headline font-weight-bold mb-2">Tempo de atendimento</div>
                  <v-icon x-large :class="vibrarAnimation ? 'shake-animation' : ''" color="primary">
                    mdi-clock-fast
                  </v-icon>
                  <div class="display-3 primary--text font-weight-bold mt-2">
                    {{ tempoAtendimento }}
                  </div>
                </v-card-text>
              </v-card>
            </v-card>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <!-- Botões de Ação -->
        <v-card-actions class="justify-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-large
                color="secondary"
                class="white--text mx-2"
                :disabled="emChamada || dialogCronometroAtendimento"
                @click="$emit('voltar')"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </template>
            <span>Voltar</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-large
                color="primary"
                class="white--text mx-2"
                :disabled="emChamada || dialogCronometroAtendimento"
                @click="clickChamar"
              >
                <v-icon>mdi-account-voice</v-icon>
              </v-btn>
            </template>
            <span>Chamar</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-large
                color="green darken-1"
                class="white--text mx-2"
                :disabled="btnOp || dialogCronometroAtendimento"
                @click="iniciarAtendimento()"
              >
                <v-icon>mdi-headset</v-icon>
              </v-btn>
            </template>
            <span>Iniciar Atendimento</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-large
                color="orange darken-1"
                class="white--text mx-2"
                :disabled="btnOp || dialogCronometroAtendimento"
                @click="naoCompareceu()"
              >
                <v-icon>mdi-clock-alert</v-icon>
              </v-btn>
            </template>
            <span>Não Compareceu</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-large
                color="green darken-1"
                class="white--text mx-2"
                :disabled="!dialogCronometroAtendimento"
                @click="encerrarCronometroAtendimento(), e1 = 2"
              >
                <v-icon>mdi-checkbox-marked-circle</v-icon>
              </v-btn>
            </template>
            <span>Finalizar Atendimento</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-large
                color="red"
                class="white--text mx-2"
                :disabled="!dialogCronometroAtendimento"
                @click="confirmarCancelarEsperaAtendimento(), isCancelarEsperaAtendimento = true"
              >
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </template>
            <span>Espera / Cancelar Atendimento</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>

      <!-- Alertas de Cancelar/Espera -->
      <v-slide-y-transition>
        <v-card v-if="isCancelarEsperaAtendimento && alertCancelarEsperaAtendimento" class="mt-4" outlined>
          <v-card-text>
            <v-select
              v-model="elementoListaEsperaCancelar1"
              :items="listaEsperaCancelar1"
              label="Escolha uma ação"
              item-value="numero"
              item-text="text"
              outlined
              class="mb-4"
            ></v-select>

            <v-card-actions class="justify-end">
              <v-btn text @click="isCancelarEsperaAtendimento = false">Voltar</v-btn>
              <v-btn
                color="primary"
                :disabled="elementoListaEsperaCancelar1 == null"
                @click="(elementoListaEsperaCancelar1 != null && elementoListaEsperaCancelar1 == 1) ? alertCancelarAtendimento = true : alertEsperaAtendimento = true, alertCancelarEsperaAtendimento = false"
              >
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-slide-y-transition>

      <!-- Alerta Cancelar Atendimento -->
      <v-slide-y-transition>
        <v-alert
          v-if="alertCancelarAtendimento"
          border="left"
          colored-border
          type="warning"
          elevation="2"
          class="mt-4"
        >
          <div class="py-3 text-center">
            Ao cancelar os dados desse atendimento serão perdidos
          </div>
          <div class="text-center">
            <v-btn text color="error" @click="alertCancelarAtendimento = !alertCancelarAtendimento, alertCancelarEsperaAtendimento = true">
              Voltar
            </v-btn>
            <v-btn text color="error" @click="cancelarAtendimento(), alertCancelarAtendimento = !alertCancelarAtendimento">
              Confirmar
            </v-btn>
          </div>
        </v-alert>
      </v-slide-y-transition>

      <!-- Alerta Espera Atendimento -->
      <v-slide-y-transition>
        <v-alert
          v-if="alertEsperaAtendimento"
          border="left"
          colored-border
          type="info"
          elevation="2"
          class="mt-4"
        >
          <div class="py-3 text-center">
            Esse atendimento será vinculado à sua lista de pendentes.
          </div>
          <div class="text-center">
            <v-btn text color="error" @click="alertEsperaAtendimento = !alertEsperaAtendimento, alertCancelarEsperaAtendimento = true">
              Voltar
            </v-btn>
            <v-btn text color="error" @click="esperaAtendimento(), alertEsperaAtendimento = !alertEsperaAtendimento">
              Confirmar
            </v-btn>
          </div>
        </v-alert>
      </v-slide-y-transition>
    </div>

    <!-- Passo 2: Cadastro OS -->
    <div v-else-if="e1 === 2" class="step-content">
      <v-card v-if="dialogOs" outlined class="mx-auto" max-width="500">
        <v-card-title class="headline primary white--text">
          Cadastro de Ordem de Serviço
        </v-card-title>

        <v-card-text class="pt-4">
          <v-radio-group v-model="selectCpf" row class="mb-4">
            <v-radio label="CPF" :value="0"></v-radio>
            <v-radio label="Ordem de Serviço" :value="1"></v-radio>
          </v-radio-group>

          <v-text-field
            v-if="selectCpf === 0"
            v-model="cpfPaciente"
            v-mask="'###.###.###-##'"
            label="CPF"
            outlined
            :loading="loadCpf"
            @input="cpfPaciente.length === 14 && buscarPacientePorCpf(unmask(cpfPaciente))"
          ></v-text-field>

          <v-alert
            v-if="nomePaciente && alertMsg !== 'alerta'"
            :type="alertCpf ? 'error' : 'success'"
            text
            dense
            class="mb-4"
          >
            {{ nomePaciente }}
          </v-alert>

          <v-alert
            v-if="alertMsg === 'alerta'"
            type="warning"
            text
            dense
            class="mb-4"
          >
            {{ nomePaciente }} não possui O.S cadastrada.
          </v-alert>

          <v-text-field
            v-model="codigoOSTemp"
            type="number"
            label="Código O.S"
            outlined
            :disabled="servicosOsLoading || selectCpf === 0"
            class="mb-4"
            @keyup.enter="retornarServicosOs()"
          ></v-text-field>

          <v-text-field
            v-model="mAnoNascimentoTemp"
            type="number"
            label="Ano de Nascimento"
            outlined
            :disabled="servicosOsLoading || selectCpf === 0"
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-end pa-4">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                color="deep-orange darken-1"
                class="white--text mr-2"
                :disabled="servicosOsLoading"
                @click="isTransferirAtendimento = true, fecharCardOS()"
              >
                <v-icon>mdi-swap-horizontal</v-icon>
              </v-btn>
            </template>
            <span>Transferir Atendimento</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                color="primary"
                class="white--text"
                :disabled="!codigoOSTemp || mAnoNascimentoTemp == null"
                :loading="servicosOsLoading"
                @click="retornarServicosOs()"
              >
                <v-icon>mdi-database-search</v-icon>
              </v-btn>
            </template>
            <span>Consultar</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>

      <!-- Alerta de Erro -->
      <v-alert
        v-if="servicosOsErro.isErro"
        type="error"
        class="mx-auto mt-4"
        max-width="500"
        outlined
      >
        <div v-if="servicosOsErro.tipo === '1'">Código não encontrado. Tente novamente</div>
        <div v-if="servicosOsErro.tipo === '2'">O.S cadastrada em outra unidade</div>
        <div v-if="servicosOsErro.tipo === '3'">O.S cadastrada em outra data</div>
        <div v-if="servicosOsErro.tipo === '4'">Ocorreu um erro. Tente novamente</div>
        <div v-if="servicosOsErro.tipo === '5'">Ano de nascimento incorreto. Tente novamente</div>
        <div v-if="servicosOsErro.tipo === '6'">Não existem exames ABERTOS para essa OS!</div>

        <v-btn text color="white" @click="fecharAlertErro()" class="mt-2">Fechar</v-btn>
      </v-alert>

      <!-- Transferir Atendimento -->
      <v-dialog v-model="isTransferirAtendimento" max-width="500" persistent>
        <v-card>
          <v-toolbar color="primary" dark>
            <v-toolbar-title>Transferir Atendimento</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="isTransferirAtendimento = false, exibirCardOS()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-4" style="height: 300px;">
            <v-subheader v-if="listaTransferirAtendimentosMedicos.length === 0">
              Não há atendimento para transferir este Paciente
            </v-subheader>

            <v-radio-group v-model="radioGroup" v-else>
              <v-radio
                v-for="(item, index) in listaTransferirAtendimentosMedicos"
                :key="index"
                :label="item.nomeEspecialidade"
                :value="index"
              ></v-radio>
            </v-radio-group>
          </v-card-text>

          <v-card-actions class="justify-end pa-4">
            <v-btn
              color="primary"
              :disabled="listaTransferirAtendimentosMedicos.length === 0"
              @click="transferirAtendimento(), isTransferirAtendimento = false"
            >
              Transferir
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!-- Passo 3: Ordenar Exames -->
    <div v-else-if="e1 === 3" class="step-content">
      <template v-if="!dialogOrdenarExames">
        <v-skeleton-loader type="card" class="mx-auto" max-width="500"></v-skeleton-loader>
      </template>

      <v-card v-else outlined class="mx-auto" max-width="500">
        <v-card-title class="headline primary white--text">
          {{ nomePaciente }}
        </v-card-title>

        <v-card-text class="pt-4" style="max-height: 500px; overflow-y: auto;">
          <v-alert
            v-if="listaExamesNaoEncontrados.length"
            type="error"
            border="left"
            colored-border
            class="mb-4"
          >
            <v-expansion-panels flat>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <v-icon left color="error">mdi-alert</v-icon>
                  {{ listaExamesNaoEncontrados.length }} exames não encontrados!
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list dense>
                    <v-list-item v-for="(item, index) in listaExamesNaoEncontrados" :key="index">
                      <v-list-item-content>
                        <v-list-item-title>{{ item }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-alert>

          <v-subheader class="title">
            {{ servicosOs.length ? 'Exames Pré-ordenados em Sequência' : 'Nenhum Exame disponível' }}
          </v-subheader>

          <draggable v-model="listaServicosAgrupados">
            <template v-for="(item, ind) in listaServicosAgrupados">
              <v-list dense :key="ind" class="pa-1" ripple>
                <v-list-item>
                  <v-list-item-action class="ma-0">
                    <v-btn icon color="red ligthen-2" @click="removeItem(ind)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-action class="ma-0">
                    <v-icon>
                      drag_indicator
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content hover>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-list-item>
                          <a v-on="on" class="ml-0">{{ item[0].nomeExame }}</a>
                        </v-list-item>
                        <v-list-item-title v-if="item.unidadePreferencia.filaExame == null">
                          <a class="black--text pl-4" v-on="on">Fila {{ item.unidadePreferencia.nomeUnidade
                            }}: 0</a>
                        </v-list-item-title>
                        <v-list-item-title v-else>
                          <a class="black--text pl-4" v-on="on">Fila {{ item.unidadePreferencia.nomeUnidade
                            }}: {{ item.unidadePreferencia.filaExame }}</a>
                        </v-list-item-title>
                      </template>
                      <div v-for="(item) in item.fila" :key="item.index">
                        <span v-if="item[0].filaExame == null">{{ item[0].nomeUnidade }}: 0</span>
                        <span v-else>{{ item[0].nomeUnidade }}: {{ item[0].filaExame }}</span>
                      </div>
                    </v-tooltip>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </template>
          </draggable>
        </v-card-text>

        <v-card-actions class="pr-4">
          <v-spacer />
          <div v-if="servicosOs.length">
            <v-btn rounded color="error" @click="novaConsulta(), e1 = 2" class="ma-1">
              Nova consulta
            </v-btn>
            <v-btn rounded color="primary" dark @click="addUnidadesServicos(), e1 = 4">
              Continuar
            </v-btn>
          </div>
          <div v-else>
            <v-btn rounded color="error" @click="novaConsulta(), e1 = 2">
              Nova consulta
            </v-btn>
            <v-btn rounded color="primary" dark @click="encerrarAtendimentoExameNaoEncontrado()">
              Sair
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </div>

    <!-- Passo 4: Finalizar Atendimento -->
    <div v-else-if="e1 === 4" class="step-content">
      <v-layout justify-center class="mb-10 mt-2" v-if="dialogCadastrarPreferencia">
        <v-card outlined max-width="420px">
          <div class="grey--text text--darken-3 text-center text-truncate pt-2">
            <h2>{{ nomePaciente }}</h2>
          </div>
          <v-card-text>
            <v-alert :value="alertPreferenciaObrigatoria" color="error" icon="priority_high">
              Há exame(s) com preferencia médica obrigatória não cadastradas
            </v-alert>
            <v-layout row align-center class="ma-2">
              <v-flex md10>
                <v-text-field v-show="!isNumero" v-model="numeroPaciente" :disabled="!isNumero"
                  label="Confirme o número do Paciente:" placeholder="Numero" outline />
                <v-text-field v-show="isNumero" v-model="numeroPacienteTemp" prepend-inner-icon="phone"
                  hint="Preencha este esse campo corretamente!!" :error="erroNumero.length != 0 && !isNumero"
                  :error-messages="erroNumero" class="pb-0 mb-0 pt-0 pa-0 ml-0"
                  label="Confirme o número do Paciente:" placeholder="Número" outline />
              </v-flex>
              <v-flex md2>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-on="on" v-bind="attrs">
                      <v-checkbox hint="Sem Número" v-model="isNumeroTemp" color="orange" />
                    </span>
                  </template>
                  <span>Sem Número</span>
                </v-tooltip>
              </v-flex>
            </v-layout>

            <v-window v-model="step" class="px-4">
              <v-window-item v-for="(item, index) in listaServicosAgrupados" :key="item.title" :value="index">
                <div class="grey--text text--darken-2 text-center text-truncate mb-4">
                  <h3>{{ item[0].nomeExame }}</h3>
                </div>
                <v-layout row>
                  <v-flex xs12>
                    <v-subheader style="margin-bottom: -10px" class="pb-0 pt-0 pl-0">
                      Unidade
                    </v-subheader>
                    <v-select v-model="item.unidadePreferencia" :items="item.unidades" menu-props="auto"
                      :return-object="true" style="margin-bottom: -20px" class="pr-0 pl-0 pb-2 pt-0"
                      label="Selecionar Unidade" hide-details item-text="nomeUnidade" single-line
                      @input="setarUnidade(item.unidadePreferencia, index)" />
                    <v-select class="mt-5" v-model="item.unidadePreferencia.idLocal"
                      :items="returnLocal(item.unidadePreferencia.locais, item[0].idExame)" menu-props="auto"
                      item-value="idLocal" style="margin-bottom: -20px" label="Selecionar local" hide-details
                      item-text="nomeLocal" single-line />
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <br>
                    <br>
                  </v-flex>
                </v-layout>

                <v-layout row align-center>
                  <v-flex xs12>
                    <v-subheader style="margin-bottom: -10px" class="pb-0 pt-0 pl-0 mr-0">
                      Médico
                    </v-subheader>
                    <v-select readonly v-model="item.medicoPreferencia.idMedico" item-value="idMedico" class="pa-0 pb-0 pt-0 mb-4" :items="item.medicos"
                      menu-props="auto" label="Selecionar Médico"
                      no-data-text="Nenhum médico para esta unidade" item-text="nome" single-line required>
                      <template slot="item" slot-scope="data">
                        <template>
                          <v-list-item-avatar>
                            <v-img v-if="data.item.online" class="pa-2" :src="require('../../assets/copygreen.png')"
                              width="15px" />
                            <v-img v-else class="pa-2" :src="require('../../assets/copy.png')" width="15px" />
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-subtitle class="font-weight-medium" v-html="data.item.nome" />
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-select>
                  </v-flex>
                </v-layout>
              </v-window-item>
            </v-window>
          </v-card-text>
          <v-card-actions class="pt-2">
            <v-btn rounded icon title="Voltar" color="deep-orange darken-3" @click="voltarOrdenarExames(), e1 = 3">
              <v-icon icon color="orange">
                arrow_back
              </v-icon>
            </v-btn>
            <input v-show="false" ref="search" type="text" class="form-control" placeholder="Focus On Me">
            <v-spacer />
            <v-btn v-show="isNumero" rounded :disabled="erroNumero.length != 0 || desabilitaBotaoAdicionar"
              color="primary" @click="organizarServicosEnviados()">
              Adicionar
            </v-btn>
            <v-btn v-show="!isNumero" rounded :disabled="desabilitaBotaoAdicionar" color="primary"
              @click="organizarServicosEnviados()">
              Adicionar
            </v-btn>
            <v-icon large :disabled="step === 0" @click="decrementarStep()">
              arrow_left
            </v-icon>
            <v-icon large :disabled="step == listaServicosAgrupados.length - 1" @click="somarStep()">
              arrow_right
            </v-icon>
          </v-card-actions>
        </v-card>
      </v-layout>

      <!-- Próximo Atendimento -->
      <v-dialog v-model="dialogProximoAtendimento" max-width="500" persistent>
        <v-card>
          <v-card-title class="headline success white--text">
            Atendimento Concluído
          </v-card-title>

          <v-card-text class="text-center pt-6">
            <v-icon x-large color="success" class="mb-4">mdi-check-circle</v-icon>

            <div v-if="mensagemIdProximaUnidade !== user.idUnidade" class="text-h5 mb-4">
              Unidade: {{ mensagemProximaUnidade }}
            </div>

            <div v-if="consultas.length === 1" class="text-h6 mb-2">
              Serviço: {{ nomeEspecialidade }}
            </div>

            <div v-if="consultas.length === 1" class="text-h6 mb-2">
              Exame: {{ nomeExame }}
            </div>

            <div class="text-h6">
              Local: {{ mensagemProximoLocalDialog }}
            </div>
          </v-card-text>

          <v-card-actions class="justify-center pb-4">
            <v-btn
              color="success"
              @click="proximoAtendimento()"
            >
              Finalizar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import SweetalertIcon from 'vue-sweetalert-icons'
import pacienteService from '../../services/paciente.service'
import {
  mask
} from 'vue-the-mask'

export default {
  name: 'atendimento',
  directives: {
    mask
  },
  components: {
    draggable
  },
  props: {
    myAtendimento: Object,
    servicos: Array,
    emChamada: Boolean,
    servicosOs: Array,
    color: {
      type: String,
      default: 'quadradoB'
    },
    colorText: {
      type: String,
      default: 'white--text'
    },
    btnOp: {
      type: Boolean,
      default: false
    },
    dialogCronometroAtendimento: {
      type: Boolean,
      default: true
    },
    tempoAtendimento: {
      type: String,
      default: '00 : 00'
    },
    dialogOs: {
      type: Boolean,
      default: true
    },
    servicosOsLoading: {
      type: Boolean,
      default: false
    },
    TextoModalHeadline: {
      type: Object,
      default: null
    },
    codigoOS: {
      type: String,
      default: ''
    },
    mAnoNascimento: {
      type: String,
      default: ''
    },
    dialogCancelarEsperaAtendimento: {
      type: Boolean,
      default: false
    },
    isCancelarAtendimento: {
      type: Boolean,
      default: false
    },
    servicosOsOk: {
      type: Boolean,
      default: false
    },
    servicosOsErro: {
      type: Object,
      default: null
    },
    listaTransferirAtendimentosMedicos: {
      type: Array,
      default: null
    },
    dialogOrdenarExames: {
      type: Boolean,
      default: false
    },
    nomePaciente: {
      type: String,
      default: ''
    },
    listaExamesNaoEncontrados: {
      type: Array,
      default: null
    },
    listaServicosAgrupados: {
      type: Array,
      default: null
    },
    dialogCadastrarPreferencia: {
      type: Boolean,
      default: false
    },
    alertPreferenciaObrigatoria: {
      type: Boolean,
      default: false
    },
    isNumero: {
      type: Boolean,
      default: true
    },
    numeroPaciente: {
      type: String,
      default: ' '
    },
    mask: {
      type: String,
      default: ' '
    },
    erroNumero: {
      type: String,
      default: ' '
    },
    step: {
      type: Number,
      default: 0
    },
    desabilitaBotaoAdicionar: {
      type: Boolean,
      default: true
    },
    dialogProximoAtendimento: {
      type: Boolean,
      default: false
    },
    mensagemIdProximaUnidade: {
      type: Number,
      default: 0
    },
    mensagemProximaUnidade: {
      type: String,
      default: ' '
    },
    consultas: {
      type: Array,
      default: null
    },
    mensagemProximoLocalDialog: {
      type: String,
      default: ' '
    },
    nomeExame: {
      type: String,
      default: ' '
    },
    nomeEspecialidade: {
      type: String,
      default: ' '
    },
    mLocais: {
      type: Array,
      default: null
    }

  },
  data () {
    return {
      e1: 1,
      isChamar: true,
      isCancelarEsperaAtendimento: false,
      listaEsperaCancelar1: [{
        text: 'Cancelar Atendimento',
        numero: '1'
      },
      {
        text: 'Adicionar em Espera',
        numero: '2'
      }
      ],
      alertMsg: '',
      loadCpf: false,
      cpfPaciente: '',
      selectCpf: 1,
      idPrecadastro: null,
      alertCpf: false,
      elementoListaEsperaCancelar1: null,
      alertCancelarAtendimento: false,
      alertEsperaAtendimento: false,
      alertCancelarEsperaAtendimento: true,
      codigoOSTemp: '',
      mAnoNascimentoTemp: null,
      isTransferirAtendimento: false,
      radioGroup: 0,
      isNumeroTemp: true,
      numeroPacienteTemp: '',
      sweetAnimation: true,
      vibrarAnimation: false

    }
  },
  methods: {
    buscarPacientePorCpf (cpf) {
      this.alertCpf = false
      this.loadCpf = true
      pacienteService.buscarPacientePorCpf(cpf).then(response => {
        this.alertMsg = response.data.msg
        if (response.data.msg === 'sucesso') {
          // console.log(response.data)
          this.nomePaciente = response.data.paciente.nome
          this.mAnoNascimentoTemp = new Date(response.data.paciente.data_nascimento).getFullYear()
          this.codigoOSTemp = response.data.preCadastro.idOs
          this.idPrecadastro = response.data.preCadastro.id
        } else if (response.data.msg === 'alerta') {
          this.nomePaciente = response.data.paciente.nome
          this.mAnoNascimentoTemp = ''
          this.codigoOSTemp = ''
        } else {
          this.nomePaciente = 'Verifique se o CPF está correto!'
          this.alertCpf = true
          this.mAnoNascimentoTemp = ''
          this.codigoOSTemp = ''
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.loadCpf = false
      })
    },
    unmask (str) {
      return str.replace(/[^\d]/g, '')
    },
    removeItem (index) {
      this.listaServicosAgrupados.splice(index, 1)
      this.$emit('verificarBotaoAdicionar', this.listaServicosAgrupados)
    },
    iniciarAtendimento () {
      this.$emit('iniciarAtendimento', true)
      console.log('iniciarAtendimento')
      this.vibrarAnimation = true
      this.dialog = false
    },
    naoCompareceu () {
      console.log('naoCompareceu')
      this.$emit('naoCompareceu', true)
      this.dialog = false
    },
    voltar () {
      this.color = 'grey lighten-5'
      this.colorText = 'black--text'
      this.isDark = false
      // this.dialog = false
    },
    clickChamar () {
      this.$emit('chamar', '')
    },
    fazerChamada () {
      this.isChamar = true
      this.dialog = true
      if (this.tipo === 1) {
        this.$emit('add-atendimento')
      }
    },
    mapearLetraPrioridade (prioridade) {
      if (prioridade === 0) {
        return 'C'
      } else if (prioridade === 1) {
        return 'P'
      } else if (prioridade === 2) {
        return 'B'
      } else if (prioridade === 3) {
        return 'A'
      }
    },
    converterDate (data) {
      var d = new Date(data)
      var minutes = d.getMinutes().toString()
      minutes = minutes.length === 1 ? '0' + minutes : minutes
      var hours = d.getHours().toString()
      hours = hours.length === 1 ? '0' + hours : hours
      return hours + ':' + minutes
    },
    encerrarCronometroAtendimento () {
      this.$emit('encerrarCronometroAtendimento', true)
    },
    confirmarCancelarEsperaAtendimento () {
      this.$emit('confirmarCancelarEsperaAtendimento', true)
    },
    retornarServicosOs () {
      if (this.idPrecadastro != null) {
        pacienteService.atualizarPrecadastro(this.idPrecadastro, 'atendido', new Date(), this.codigoOSTemp).then(response => {
          console.log(response)
        }).catch(error => {
          console.log(error)
        })
      }
      this.$emit('retornarServicosOs', {
        codigoOS: this.codigoOSTemp,
        mAnoNascimento: this.mAnoNascimentoTemp
      })
    },
    esperaAtendimento () {
      this.$emit('esperaAtendimento', true)
    },
    cancelarAtendimento () {
      this.$emit('cancelarAtendimento', true)
    },
    mudarDialogCancelarEsperaAtendimento () {
      this.$emit('mudarDialogCancelarEsperaAtendimento', 1, true)
    },
    transferirAtendimento () {
      this.$emit('transferirAtendimento', this.radioGroup)
    },
    fecharAlertErro () {
      this.$emit('fecharAlertErro', true)
    },
    exibirCardOS () {
      this.$emit('exibirCardOS', true)
    },
    fecharCardOS () {
      this.$emit('fecharCardOS', true)
    },
    novaConsulta () {
      this.$emit('novaConsulta', true)
    },
    addUnidadesServicos () {
      this.numeroPacienteTemp = this.numeroPaciente
      this.$emit('addUnidadesServicos', true)
    },
    returnLocal (locais, id) {
      var mLocais = locais.filter(e => e.idExame === id)
      mLocais.push({
        idLocal: 0,
        nomeLocal: 'Sem preferência'
      })
      return mLocais
    },
    encontrarMedicoPorId (idMedico, listaMedicos) {
      // Verifica se o parâmetro listaMedicos é realmente um array
      // idMedico = 2
      console.log('-----> -: ', idMedico, listaMedicos)

      if (!Array.isArray(listaMedicos)) {
        console.error('A lista de médicos fornecida não é um array.')
        return null
      }

      // Procura o médico cujo idMedico corresponda
      const medicoEncontrado = listaMedicos.find(medico => medico.idMedico === idMedico)

      // Retorna o médico encontrado ou defalt
      return medicoEncontrado || { nomeMedico: 'Sem preferência', idMedico: '' }
    },

    somarStep () {
      this.$emit('somarStep', true)
    },
    decrementarStep () {
      this.$emit('decrementarStep', true)
    },
    organizarServicosEnviados () {
      this.$emit('organizarServicosEnviados', true)
    },
    proximoAtendimento () {
      this.$emit('proximoAtendimento', true)
    },
    setarUnidade (unidade, index) {
      this.$emit('setarUnidade', unidade, index)
    },
    voltarOrdenarExames () {
      this.$emit('voltarOrdenarExames', true)
    },
    encerrarAtendimentoExameNaoEncontrado () {
      this.$emit('encerrarAtendimentoExameNaoEncontrado', true)
    }

  },
  watch: {
    selectCpf: function (val) {
      this.nomePaciente = ''
      if (val === 0) {
        this.codigoOSTemp = ''
        this.mAnoNascimentoTemp = null
      } else {
        this.cpfPaciente = ''
      }
    },
    cpfPaciente: function (val) {
      if (val.length === 14) {
        this.buscarPacientePorCpf(this.unmask(val))
      }
    },
    markColor: function (val) {
      this.color = val
    },
    servicosOsOk: function (val) {
      console.log('val ' + val)
      if (val === true) {
        this.e1 = 3
      }
    },
    isNumeroTemp: function (val) {
      this.$emit('alteraIsNumero', val)
    },
    numeroPacienteTemp: function (val) {
      this.$emit('alteraNumeroPaciente', val)
    },
    dialogProximoAtendimento: function (val) {
      setTimeout(() => {
        this.sweetAnimation = false
        this.sweetAnimation = true
      }, '500')
    }
  },
  mounted () {

  },
  created () {
    this.user = this.$store.getters.usuario
  }
}
</script>

<style scoped>
/* Estilos gerais */
.v-stepper {
  background-color: #f5f5f5 !important;
}

.v-stepper__header {
  box-shadow: none !important;
  border-bottom: 1px solid #e0e0e0;
}

.v-stepper__step {
  padding: 12px 24px !important;
}

.v-stepper__step--active .v-stepper__step__step {
  background-color: var(--v-primary-base) !important;
}

.v-stepper__step--complete .v-stepper__step__step {
  background-color: var(--v-success-base) !important;
}

/* Estilo dos cards */
.v-card {
  transition: all 0.3s ease;
  border-radius: 8px !important;
}

.v-card:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1) !important;
}

/* Animação do cronômetro */
.shake-animation {
  animation: shake 1.5s infinite;
}

@keyframes shake {
  0%, 100% { transform: translateX(0) rotate(0deg); }
  20% { transform: translateX(-5px) rotate(-5deg); }
  40% { transform: translateX(5px) rotate(5deg); }
  60% { transform: translateX(-5px) rotate(-5deg); }
  80% { transform: translateX(5px) rotate(5deg); }
}

/* Estilo do drag and drop */
.drag-handle {
  cursor: move;
  cursor: grab;
}

.drag-handle:active {
  cursor: grabbing;
}

/* Estilo para a lista numerada */
ol.rounded-list {
  counter-reset: li;
  list-style: none;
  padding: 0;
  margin-bottom: 4em;
  text-shadow: 0 1px 0 rgba(255, 255, 255, .5);
}

.rounded-list a {
  position: relative;
  display: block;
  padding: .4em .4em .4em 2em;
  margin: .5em 0;
  background: #ddd;
  color: #444;
  text-decoration: none;
  border-radius: .3em;
  transition: all .3s ease-out;
}

.rounded-list a:hover {
  background: #eee;
}

.rounded-list a:hover:before {
  transform: rotate(360deg);
}

.rounded-list a:before {
  content: counter(li);
  counter-increment: li;
  position: absolute;
  left: -1.3em;
  top: 50%;
  margin-top: -1.3em;
  background: #00BCD4;
  height: 2em;
  width: 2em;
  line-height: 2em;
  border: .3em solid #fff;
  text-align: center;
  font-weight: bold;
  border-radius: 2em;
  transition: all .4s ease-out;
}

/* Estilo para o cronômetro */
.cronometro {
  font-family: "Teko", sans-serif;
  font-size: 90px;
}

/* Responsividade */
@media (max-width: 960px) {
  .v-stepper__header {
    flex-direction: column;
    align-items: flex-start;
  }

  .v-stepper__step {
    width: 100%;
    justify-content: flex-start;
  }

  .v-divider {
    display: none;
  }
}

/* Efeito de hover para os itens da lista */
.v-list-item {
  transition: background-color 0.3s ease;
}

.v-list-item:hover {
  background-color: #f5f5f5;
}

/* Ajuste fino para mobile */
@media (max-width: 600px) {
  .v-card__title {
    font-size: 1.25rem !important;
    padding: 16px !important;
  }

  .v-card__text {
    padding: 16px !important;
  }

  .v-btn {
    min-width: auto !important;
    padding: 0 12px !important;
  }

  .cronometro {
    font-size: 2.5rem;
  }
}
</style>
